import { Link } from "react-router-dom";
import { GOOGLE_FORM_URL } from "../constants";
import {
  ArrowDown,
  ArrowUpRight,
  Camera,
  Clock3,
  FileVideo,
  Mail,
  ShieldCheck,
  Sparkles,
} from "lucide-react";
import { TIKTOK_URL } from "../constants";

const rules = [
  {
    number: "01",
    title: "Videoclipul îți aparține",
    text: "Trimite doar imagini filmate de tine sau pentru care ai acordul clar al autorului.",
  },
  {
    number: "02",
    title: "Fără conținut regizat",
    text: "Căutăm momente reale și neașteptate din trafic, nu situații create intenționat.",
  },
  {
    number: "03",
    title: "Protejăm oamenii",
    text: "Nu acceptăm imagini grafice, răni grave sau conținut care pune pe cineva în pericol.",
  },
  {
    number: "04",
    title: "Respectăm intimitatea",
    text: "Numerele de înmatriculare și fețele pot fi mascate înainte de publicare, când este necesar.",
  },
  {
    number: "05",
    title: "Acord pentru monetizare",
    text: "Prin trimiterea unui videoclip, îți exprimi acordul ca LUTUU să îl publice și să îl monetizeze pe rețelele sociale. Înțelegi și accepți că videoclipul trimis de tine poate genera venituri pentru creatorul LUTUU.",
  },
];

export default function Home() {
  const scrollToRules = () => {
    document.getElementById("reguli")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <section id="acasa" className="hero">
        <img src="/assets/lutuu-trafic-hero.png" alt="Trafic urban văzut printr-un parbriz într-o noapte ploioasă" />
        <div className="hero-shade" />
        <div className="hero-grid" />
        <div className="hero-content">
          <div className="eyebrow reveal-1"><span /> Comunitatea #LUTUU</div>
          <h1 className="reveal-2">Ai surprins ceva<br /><em>nebun în trafic?</em></h1>
          <p className="hero-copy reveal-3">
            Trimite-ne momentul filmat de tine. Cele mai memorabile întâmplări pot ajunge în comunitatea <strong>@imlutuu</strong>.
          </p>
          <div className="hero-actions reveal-4">
            <a className="primary-btn" href={GOOGLE_FORM_URL} target="_blank" rel="noopener noreferrer">
              <FileVideo size={19} /> Trimite videoclipul
            </a>
            <button className="text-btn" onClick={scrollToRules}>
              Citește regulile <ArrowDown size={18} />
            </button>
          </div>
        </div>
        <div className="hero-side-note">
          <span>DIN TRAFIC. PE BUNE.</span>
          <i />
          <span>ROMÂNIA</span>
        </div>
        <div className="scroll-cue"><ArrowDown size={17} /><span>Descoperă</span></div>
      </section>

      <section id="reguli" className="rules-section section-pad">
        <div className="section-heading">
          <div>
            <p className="kicker">Înainte să trimiți</p>
            <h2>Regulile<br /><span>comunității</span></h2>
          </div>
          <p className="heading-copy">
            Vrem imagini autentice, sigure și publicate cu respect. Citește aceste cinci reguli înainte să trimiți un videoclip.
          </p>
        </div>

        <div className="rules-grid">
          {rules.map((rule) => (
            <article className="rule-card" key={rule.number}>
              <div className="rule-top"><span>{rule.number}</span><ShieldCheck size={23} /></div>
              <h3>{rule.title}</h3>
              <p>{rule.text}</p>
            </article>
          ))}
        </div>

        <div className="important-note">
          <div className="note-icon"><Sparkles size={25} /></div>
          <div>
            <span>De reținut</span>
            <p>Nu filma și nu folosi telefonul în timp ce conduci. Siguranța este întotdeauna mai importantă decât orice cadru.</p>
          </div>
        </div>
      </section>

      <section id="cum-functioneaza" className="process-section section-pad">
        <div className="process-intro">
          <p className="kicker">Simplu și direct</p>
          <h2>De la cameră<br />la comunitate.</h2>
          <p>Tu surprinzi momentul. Noi îl verificăm și, dacă se potrivește, îl transformăm într-o poveste pentru comunitatea LUTUU.</p>
          <a href={TIKTOK_URL} target="_blank" rel="noreferrer">Vezi profilul @imlutuu <ArrowUpRight size={17} /></a>
        </div>
        <div className="steps">
          <div className="step">
            <span className="step-number">01</span>
            <div className="step-icon"><Camera /></div>
            <div><h3>Ai filmat</h3><p>Un moment real, surprins în trafic în condiții de siguranță.</p></div>
          </div>
          <div className="step">
            <span className="step-number">02</span>
            <div className="step-icon"><Mail /></div>
            <div><h3>Ne scrii</h3><p>Completezi detaliile și atașezi videoclipul în aplicația ta de email.</p></div>
          </div>
          <div className="step">
            <span className="step-number">03</span>
            <div className="step-icon"><Clock3 /></div>
            <div><h3>Noi verificăm</h3><p>Analizăm materialul și revenim dacă avem nevoie de informații suplimentare.</p></div>
          </div>
        </div>
      </section>

      <section className="home-cta section-pad">
        <div>
          <p className="kicker">Ești gata?</p>
          <h2>Trimite-ne<br /><span>clipul acum.</span></h2>
        </div>
        <a className="primary-btn" href={GOOGLE_FORM_URL} target="_blank" rel="noopener noreferrer">
          <FileVideo size={19} /> Deschide formularul
        </a>
      </section>
    </>
  );
}
